"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const shippingdeadlinebrand03 = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 71 60",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-shippingdeadlinebrand03` : '') + (description ? ` desc-shippingdeadlinebrand03` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-shippingdeadlinebrand03"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-shippingdeadlinebrand03"
  }, description), /*#__PURE__*/_react.default.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M31.585 4.78a2.418 2.418 0 0 1 1.92 0l25.188 10.93a2.394 2.394 0 0 1 1.44 2.196l-.001 16.232c1.76.049 3.51.528 5.086 1.436a10.742 10.742 0 0 1 5.385 9.306c0 3.84-2.053 7.387-5.385 9.307a10.79 10.79 0 0 1-13.903-2.732l-16.611 7.538a2.404 2.404 0 0 1-1.92.031L6.434 48.068a2.394 2.394 0 0 1-1.476-2.21V17.906c0-.952.565-1.814 1.44-2.195L31.585 4.78Z",
    fill: "#FFB499",
    fillOpacity: ".5"
  }), /*#__PURE__*/_react.default.createElement("g", {
    fill: "#F04C24"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M27.667.28a3.412 3.412 0 0 1 2.708 0l25.131 10.905a3.389 3.389 0 0 1 2.037 3.107v11.156a1 1 0 1 1-2 0V14.292c0-.552-.327-1.052-.835-1.273L29.582 2.116a1.413 1.413 0 0 0-1.12 0L3.335 13.019a1.389 1.389 0 0 0-.835 1.273v27.885a1.388 1.388 0 0 0 .856 1.281l26.289 10.93c.353.147.752.143 1.102-.011l11.97-5.963a1 1 0 0 1 .893 1.79L31.62 56.177l-.032.015a3.398 3.398 0 0 1-2.713.044L2.588 45.305A3.389 3.389 0 0 1 .5 42.177V14.292c0-1.348.8-2.568 2.037-3.107L27.667.28Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M1.02 12.525a1 1 0 0 1 1.307-.54l28.275 11.757a1 1 0 0 1-.768 1.847L1.559 13.833a1 1 0 0 1-.54-1.308Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M57.02 12.508a1 1 0 0 1-.497 1.324L30.63 25.576a1 1 0 1 1-.826-1.821L55.697 12.01a1 1 0 0 1 1.323.497Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M16.6 5.36a1 1 0 0 1 1.332-.476l26.566 12.604a1 1 0 0 1-.857 1.808L17.075 6.69A1 1 0 0 1 16.6 5.36ZM30.218 23.666a1 1 0 0 1 1 1v30.906a1 1 0 0 1-2 0V24.665a1 1 0 0 1 1-1ZM50.36 30.827a11.789 11.789 0 0 1 11.767 0A11.742 11.742 0 0 1 68.013 41c0 4.197-2.244 8.075-5.886 10.173a11.79 11.79 0 0 1-11.767 0A11.742 11.742 0 0 1 44.474 41c0-4.198 2.245-8.075 5.886-10.173Zm10.769 1.733a9.79 9.79 0 0 0-9.77 0A9.742 9.742 0 0 0 46.473 41a9.742 9.742 0 0 0 4.884 8.44 9.79 9.79 0 0 0 9.771 0A9.742 9.742 0 0 0 66.013 41a9.742 9.742 0 0 0-4.884-8.44Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M56.245 34.86a1 1 0 0 1 1 1v4.7l5.293 4.841a1 1 0 0 1-1.35 1.476l-5.618-5.14a1 1 0 0 1-.325-.737v-5.14a1 1 0 0 1 1-1Z"
  }))));
};
var _default = exports.default = shippingdeadlinebrand03;